var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowUpLightV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline / Arrows / Arrow Up",
    clipPath: "url(#clip0_7979_281547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88094 2.04677C4.78331 1.94914 4.62502 1.94914 4.52739 2.04677L2.52739 4.04677C2.42975 4.1444 2.42975 4.30269 2.52739 4.40033C2.62502 4.49796 2.78331 4.49796 2.88094 4.40033L4.45416 2.8271L4.45416 7.55688C4.45416 7.69495 4.56609 7.80688 4.70416 7.80688C4.84223 7.80688 4.95416 7.69495 4.95416 7.55688L4.95416 2.8271L6.52739 4.40033C6.62502 4.49796 6.78331 4.49796 6.88094 4.40033C6.97857 4.30269 6.97857 4.1444 6.88094 4.04677L4.88094 2.04677Z",
    fill: "white",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7979_281547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.702698 8.88965)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUpLightV2);
export default __webpack_public_path__ + "static/media/icon-arrow-up-light-v2.f7c26fc3af9138637f3a59bf60b4d7a7.svg";
export { ForwardRef as ReactComponent };